import React, { useEffect, useState } from 'react'
import { useParams, useLocation, useHistory } from 'react-router-dom'
import config from '../../config'
import { doRequest } from 'middleware'
import { AuthActionTypes } from 'actions/auth'
import { isSessionValid } from '../../util/session'
import { SessionState } from 'reducers/session'
import { resetDateFilters, setLocalStorage } from '../../util'

export function AuthOIDCHandler() {
  const { orgId } = useParams<{ orgId: string }>()
  const location = useLocation()
  const history = useHistory()

  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [error, setError] = useState<string | null>(null)

  const handleLoginResponse = (session: SessionState) => {
    if (!isSessionValid(session)) {
      throw new Error('session data from credentials login was not valid')
    }

    setLocalStorage(config.sessionKey, session)
    window.dispatchEvent(new Event('toggle-theme'))
    // AB#8587 Lead list date filters should be reset on every user session
    resetDateFilters()
    //send the user back to root
    history.push('/')
  }

  useEffect(() => {
    const hashParams = new URLSearchParams(location.hash.replace(/^#/, ''))

    const code = hashParams.get('code')
    const state = hashParams.get('state') //may or may not be present

    if (!code) {
      setStatus('error')
      setError('Missing OIDC code in callback URL')
      return
    }

    // Call backend with orgId + code
    doRequest({
      url: `${config.api}/authenticate/oidc`,
      method: 'POST',
      payload: {
        orgId,
        code,
        state,
      },
      validateStatus: (status) => status === 200,
      type: AuthActionTypes.OIDCCallback,
    })
      .then((res) => {
        if (!res) throw new Error('Invalid SSO response from server')
        setStatus('success')
        handleLoginResponse(res.data as SessionState)
      })
      .catch((err: any) => {
        console.error(err)
        setStatus('error')
        setError(`Failed to authenticate: ${err?.response?.data?._message || 'SSO error'}`)
      })
  }, [orgId, location.search])

  return (
    <div className="LoginScreen">
      <div className="Login">
        {status === 'loading' && (
          <div className="form">
            <h2>Signing you in…</h2>
          </div>
        )}
        {status === 'error' && (
          <div className="form">
            <h2>Authentication Error</h2>
            <p>{error}</p>
          </div>
        )}
        {status === 'success' && (
          <div className="form">
            <h2>Success! Redirecting…</h2>
          </div>
        )}
      </div>
    </div>
  )
}
